import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ApplicationClientCommonModule, MasterDetailModule } from "@sdbn/common";

import { CommonTranslationModule } from "@sdbn/common";
import { DictionaryModule } from "@sdbn/common";
import { TmcYardCommonModule } from "../common.module";
import { StructureSelectionDialogComponent } from "./structure-selection-dialog/component/structure-selection-dialog/structure-selection-dialog.component";
import { StructureSelectionFieldComponent } from "./structure-selection-field/component/structure-selection-field.component";
import { StationDetailsComponent } from "./structure-selection/component/station-details/station-details.component";
import { StructureSelectionComponent } from "./structure-selection/component/structure-selection/structure-selection.component";

import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from "@angular/material/input";

@NgModule({
  declarations: [
    StructureSelectionDialogComponent,
    StationDetailsComponent,
    StructureSelectionFieldComponent,
    StructureSelectionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    ApplicationClientCommonModule,
    DictionaryModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    MasterDetailModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: [
    StructureSelectionDialogComponent,
    StationDetailsComponent,
    StructureSelectionFieldComponent,
    StructureSelectionComponent
  ]
})
export class StructureSelectionModule { }
